import React from 'react'
import Home from '../components/LandingPage/Home'

const HomePage = () => {
  return (
    <Home/>
  )
}

export default HomePage